<div #reportContainer [style]="{ height: heigth, width: '100%' }"></div>
<div *ngIf="isZoomEnabled" class="slider-container">
  <div class="slider-container">
    <label class="zoom-label">{{ zoomLevel }}%</label>
    <div class="zoom-controls">
      <button class="zoom-button" (click)="decreaseZoom()" title="Disminuir Zoom"
      aria-label="Disminuir Zoom">-</button>
      <input
        class="zoom-slider"
        type="range"
        min="50"
        max="200"
        [value]="zoomLevel"
        (input)="onZoomChange($event)"
      />
      <button class="zoom-button" (click)="increaseZoom()" title="Aumentar Zoom"
      aria-label="Aumentar Zoom">+</button>
      <button class="reset-button" (click)="resetZoom()" title="Volver a tamaño original"
      aria-label="Volver a tamaño original"></button>
      <div class="social-buttons">
        <div
          class="fb-share-button social-button"
          [attr.data-href]="currentUrl"
          data-layout="icon"
          data-size="large"
          data-lazy="true">
        </div>
        <button class="social-button x" (click)="share('x')" title="Compartir en X"
        aria-label="Compartir en X"></button>
      </div>
      <div class="send-button-container">
        <a [href]="mailtoLink" class="send-button" title="Enviar Reporte">
          <i class="fa fa-envelope custom-email-icon"></i>
        </a>
      </div>
    </div>
  </div>
</div>